/* SC Desktop Menu behaviour (990px and up). The inline script in sections/sc-desktop-menu.liquid
   mounts the trigger row into the theme header; this file wires it up.
   Hover opens after the section's delay (mouse and trackpad only). Click, tap, Enter and Space
   toggle. Escape closes and returns focus. Images load on first open. One promo per column. */
(function () {
  'use strict';

  var MQ = window.matchMedia('screen and (min-width: 990px)');
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)');
  var dm = window.scDm = window.scDm || {};
  var html = document.documentElement;

  function push(cfg, ev, params) {
    if (!cfg.track) return;
    var data = { event: ev, mm_device: 'desktop' };
    for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) data[k] = params[k];
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }

  /* "YYYY-MM-DD" -> local midnight (start) or 23:59:59.999 (end). Anything else = no limit. */
  function dayEdge(value, isEnd) {
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(String(value || '').trim());
    if (!m) return null;
    var d = isEnd ? new Date(+m[1], +m[2] - 1, +m[3], 23, 59, 59, 999) : new Date(+m[1], +m[2] - 1, +m[3], 0, 0, 0, 0);
    return isNaN(d.getTime()) ? null : d.getTime();
  }
  function isLive(el, now) {
    var from = dayEdge(el.getAttribute('data-from'), false);
    var to = dayEdge(el.getAttribute('data-to'), true);
    if (from !== null && now < from) return false;
    if (to !== null && now > to) return false;
    return true;
  }

  function hydrate(scope) {
    if (!scope || scope.__dmHyd) return;
    scope.__dmHyd = true;
    var imgs = scope.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.getAttribute('data-srcset')) { img.setAttribute('srcset', img.getAttribute('data-srcset')); img.removeAttribute('data-srcset'); }
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src');
    }
  }

  function preset(key, bq) {
    try {
      if (key) window.sessionStorage.setItem('scbq_preset', JSON.stringify({ k: key, bq: bq, t: Date.now() }));
      else window.sessionStorage.removeItem('scbq_preset');
    } catch (e) { /* storage blocked: the link still carries the bird */ }
  }

  function initFind(box) { if (dm.initFind) dm.initFind(box); }

  /* Quiz card "Match the promo": its bottom lines up with the live promo in another column of the
     same panel. Re-measured when the promo or panel changes size (image load, resize, column 3
     hidden under 1100px). No visible promo = the card fits its content. */
  function fitQuiz(q) {
    var pin = q.closest('.sc-dm-pin');
    var ps = pin ? pin.querySelectorAll('.sc-dm-promo.is-live') : [];
    var pr = null;
    for (var i = 0; i < ps.length; i++) if (ps[i].offsetHeight && !q.parentNode.contains(ps[i])) { pr = ps[i]; break; }
    var h = pr ? Math.round(pr.getBoundingClientRect().bottom - q.getBoundingClientRect().top) : 0;
    q.style.minHeight = h > 0 ? h + 'px' : '';
  }
  function matchQuiz(panel) {
    var qs = panel.querySelectorAll('.sc-dm-quiz--match');
    for (var i = 0; i < qs.length; i++) {
      var q = qs[i], pin = q.closest('.sc-dm-pin');
      fitQuiz(q);
      if (q.__dmRo || !pin || !window.ResizeObserver) continue;
      q.__dmRo = new ResizeObserver(fitQuiz.bind(null, q));
      q.__dmRo.observe(pin);
      Array.prototype.forEach.call(pin.querySelectorAll('[data-dm-promo]'), function (p) { q.__dmRo.observe(p); });
    }
  }

  /* ---------- Header icons: desktop colour, cart animation ---------- */
  function setIcons(cfg, on) {
    var hdr = document.getElementById('SiteHeader');
    if (!hdr) return;
    var icons = hdr.querySelectorAll('.header-item--icons lord-icon');
    for (var i = 0; i < icons.length; i++) {
      var ic = icons[i];
      if (!ic.hasAttribute('data-sc-dm-colors')) {
        ic.setAttribute('data-sc-dm-colors', ic.getAttribute('colors') || '');
        ic.setAttribute('data-sc-dm-trigger', ic.getAttribute('trigger') || '');
      }
      if (on) {
        if (cfg.iconColor) ic.setAttribute('colors', 'primary:' + cfg.iconColor + ',secondary:' + cfg.iconColor);
        if (cfg.cartAnim === 'hover' && ic.closest('.js-drawer-open-cart') && ic.getAttribute('trigger') === 'loop') ic.setAttribute('trigger', 'hover');
      } else {
        ic.setAttribute('colors', ic.getAttribute('data-sc-dm-colors'));
        if (ic.getAttribute('data-sc-dm-trigger')) ic.setAttribute('trigger', ic.getAttribute('data-sc-dm-trigger'));
      }
    }
  }

  /* ---------- Menu ---------- */
  function Menu(root, nav) {
    this.root = root;
    this.nav = nav;
    this.cfg = {
      openDelay: parseInt(root.getAttribute('data-open-delay'), 10) || 0,
      closeDelay: parseInt(root.getAttribute('data-close-delay'), 10) || 300,
      track: root.getAttribute('data-track') !== 'false',
      iconColor: root.getAttribute('data-icon-color') || '',
      cartAnim: root.getAttribute('data-cart-anim') || 'keep'
    };
    this.openP = null;
    this.openedBy = null;
    this.openedAt = 0;
    this.openY = 0;
    this.tOpen = null;
    this.tClose = null;
    this.pinned = false;
    this.seenPromo = {};
    this.bind();
    setIcons(this.cfg, MQ.matches);
  }

  Menu.prototype.trig = function (p) { return this.nav.querySelector('.sc-dm-trig[data-dm-p="' + p + '"]'); };
  Menu.prototype.panel = function (p) { return this.nav.querySelector('.sc-dm-panel[data-dm-panel="' + p + '"]'); };
  Menu.prototype.clearT = function () { clearTimeout(this.tOpen); clearTimeout(this.tClose); };

  Menu.prototype.place = function () {
    var hdr = document.getElementById('SiteHeader');
    if (!hdr) return;
    var b = hdr.getBoundingClientRect().bottom;
    this.nav.style.setProperty('--sc-dm-top', Math.max(0, Math.round(b)) + 'px');
  };

  Menu.prototype.pickPromos = function (panel) {
    var now = Date.now();
    var name = panel.getAttribute('data-dm-name') || '';
    var cols = panel.querySelectorAll('.sc-dm-col');
    for (var c = 0; c < cols.length; c++) {
      var promos = cols[c].querySelectorAll('[data-dm-promo]');
      var picked = false;
      for (var i = 0; i < promos.length; i++) {
        var on = !picked && isLive(promos[i], now);
        promos[i].classList.toggle('is-live', on);
        if (on) {
          picked = true;
          var pn = promos[i].getAttribute('data-dm-promo');
          if (!this.seenPromo[pn]) {
            this.seenPromo[pn] = true;
            push(this.cfg, 'menu_promo_view', { mm_tab: name, mm_promo_name: pn, mm_promo_slot: 'col' + (c + 1) });
          }
        }
      }
    }
  };

  Menu.prototype.open = function (p, by) {
    var panel = this.panel(p);
    if (!panel) return;
    if (this.openP === p) return;
    if (this.openP) this.close(true);
    this.place();
    hydrate(panel);
    this.pickPromos(panel);
    panel.classList.add('is-open');
    matchQuiz(panel);
    this.trig(p).setAttribute('aria-expanded', 'true');
    this.openP = p;
    this.openedBy = by;
    this.openedAt = Date.now();
    this.openY = window.scrollY;
    push(this.cfg, 'menu_open', { mm_tab: panel.getAttribute('data-dm-name') || String(p), mm_open_by: by });
  };

  Menu.prototype.close = function (quiet) {
    if (!this.openP) return;
    var panel = this.panel(this.openP), t = this.trig(this.openP);
    if (panel) panel.classList.remove('is-open');
    if (t) t.setAttribute('aria-expanded', 'false');
    this.openP = null;
    this.openedBy = null;
    if (!quiet) this.pinned = false;
  };

  Menu.prototype.bind = function () {
    var self = this, nav = this.nav;
    var trigs = nav.querySelectorAll('.sc-dm-trig');

    Array.prototype.forEach.call(trigs, function (t) {
      var p = t.getAttribute('data-dm-p');
      t.addEventListener('click', function () {
        self.clearT();
        var fresh = self.openedBy === 'hover' && Date.now() - self.openedAt < 700;
        if (self.openP === p && !fresh) self.close();
        else if (self.openP === p) self.openedBy = 'click';
        else self.open(p, 'click');
      });
      t.addEventListener('pointerenter', function (e) {
        hydrate(self.panel(p));
        if (e.pointerType !== 'mouse' || !FINE.matches || self.pinned) return;
        self.clearT();
        if (self.openP && self.openP !== p) { self.tOpen = setTimeout(function () { self.open(p, 'hover'); }, 90); return; }
        if (!self.openP) self.tOpen = setTimeout(function () { self.open(p, 'hover'); }, self.cfg.openDelay);
      });
      t.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(self.tOpen);
      });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          self.open(p, 'key');
          var first = self.panel(p).querySelector('a[href], input, button');
          if (first) first.focus();
        }
      });
    });

    nav.addEventListener('pointerenter', function () { clearTimeout(self.tClose); });
    nav.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse' || self.pinned) return;
      clearTimeout(self.tOpen);
      if (!self.openP) return;
      var a = document.activeElement;
      if (a && a.matches && a.matches('[data-dm-find-q]') && nav.contains(a) && a.value) return; /* typing a bird: stay open */
      self.tClose = setTimeout(function () { self.close(); }, self.cfg.closeDelay);
    });

    nav.addEventListener('focusout', function () {
      setTimeout(function () {
        if (!self.openP || self.pinned) return;
        if (!nav.contains(document.activeElement) && !nav.matches(':hover')) self.close();
      }, 0);
    });

    nav.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !self.openP) return;
      var t = self.trig(self.openP);
      self.close();
      if (t) t.focus();
    });

    /* Find boxes and clicks */
    Array.prototype.forEach.call(nav.querySelectorAll('[data-dm-find]'), initFind);
    nav.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-dm-item]');
      if (!a) return;
      var panel = a.closest('.sc-dm-panel');
      var items = panel ? Array.prototype.slice.call(panel.querySelectorAll('a[data-dm-item]')) : [];
      var type = a.getAttribute('data-dm-type') || 'row';
      var key = a.getAttribute('data-dm-key') || '';
      if (type === 'bird_chip' || type === 'bird_search') preset(key, type === 'bird_chip' ? 'desk_chip' : 'desk_search');
      else if (type === 'bird_search_none') preset('', '');
      var data = {
        mm_tab: panel ? panel.getAttribute('data-dm-name') : '',
        mm_type: type,
        mm_item: (a.getAttribute('data-dm-name') || '').slice(0, 60),
        mm_position: items.indexOf(a) + 1,
        mm_url: a.getAttribute('href') || ''
      };
      var promo = a.closest('[data-dm-promo]');
      if (promo) {
        data.mm_promo_name = promo.getAttribute('data-dm-promo');
        push(self.cfg, 'menu_promo_click', data);
      }
      push(self.cfg, 'menu_click', data);
    });

    var pill = document.querySelector('.sc-dm-pillwrap[data-sc-dm-owned] .sc-dm-pill') || document.querySelector('html.sc-dm-active .sc-byob--desktop a.sc-byob__pill');
    if (pill && !pill.__dm) {
      pill.__dm = true;
      pill.addEventListener('click', function () {
        push(self.cfg, 'menu_click', { mm_tab: 'header', mm_type: 'pill', mm_item: (pill.getAttribute('aria-label') || pill.textContent || '').trim().slice(0, 60), mm_position: 0, mm_url: pill.getAttribute('href') || '' });
      });
    }
  };

  /* Document-level listeners, bound once and routed to the current menu */
  var current = null;
  function onDocPointer(e) {
    if (!current || !current.openP || current.pinned) return;
    if (!current.nav.contains(e.target)) current.close();
  }
  function onScroll() {
    if (!current || !current.openP) return;
    if (!current.pinned && Math.abs(window.scrollY - current.openY) > 120) { current.close(); return; }
    current.place();
  }
  function onResize() {
    if (!current) return;
    if (!MQ.matches) { current.close(); return; }
    if (current.openP) current.place();
  }
  document.addEventListener('pointerdown', onDocPointer, true);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);
  var onMq = function (e) {
    if (!current) return;
    if (!e.matches) { current.close(); setIcons(current.cfg, false); }
    else setIcons(current.cfg, true);
  };
  if (MQ.addEventListener) MQ.addEventListener('change', onMq);

  function attach(root) {
    var nav = document.querySelector('[data-sc-dm-owned="' + root.id + '"].sc-dm-nav');
    if (!nav || nav.__dmMenu) return;
    nav.__dmMenu = new Menu(root, nav);
    current = nav.__dmMenu;
  }
  dm.onMount = attach;

  function rootEl() { return document.querySelector('.sc-dm-root'); }
  function boot() {
    var root = rootEl();
    if (!root || !MQ.matches) return;
    if (dm.mount && dm.mount(root)) attach(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  if (MQ.addEventListener) MQ.addEventListener('change', function (e) { if (e.matches) boot(); });

  /* ---------- Theme editor ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector && e.target.querySelector('.sc-dm-root');
    if (root) { if (dm.mount) dm.mount(root, true); attach(root); return; }
    var r = rootEl(); /* another section reloaded (for example the header): put the menu back if it was lost */
    if (r && dm.mount && dm.mount(r)) attach(r);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target.querySelector || !e.target.querySelector('.sc-dm-root')) return;
    var owned = document.querySelectorAll('[data-sc-dm-owned]');
    for (var i = 0; i < owned.length; i++) owned[i].parentNode.removeChild(owned[i]);
    if (current) setIcons(current.cfg, false);
    current = null;
    html.classList.remove('sc-dm-active');
  });
  document.addEventListener('shopify:block:select', function (e) {
    if (!current) return;
    var id = e.detail && e.detail.blockId;
    var el = id && current.nav.querySelector('[data-dm-block="' + id + '"]');
    var panel = el && el.closest('.sc-dm-panel');
    if (!panel) return;
    current.close();
    current.open(panel.getAttribute('data-dm-panel'), 'editor');
    current.pinned = true;
    var promo = el.closest('[data-dm-promo]');
    if (promo) { /* show the selected promo even if it is out of date or not first */
      var col = promo.closest('.sc-dm-col');
      Array.prototype.forEach.call(col.querySelectorAll('[data-dm-promo]'), function (p) { p.classList.toggle('is-live', p === promo); });
    }
  });
  document.addEventListener('shopify:block:deselect', function () {
    if (current) { current.pinned = false; current.close(); }
  });
})();
